export const QR_PAYMENTS = "qr-payments";
export const QR_PAYMENTS_TABLE_TITLE = "Manage QR Payments";

export const DEFAULT_COUNTRY_CODE = "+91";

export const QR_DEFAULT_PAGE = 1;
export const QR_DEFAULT_PAGE_SIZE = 25;

export const DEFAULT_QUANTITY = 1;
export const APPOINTMENT_PLACEHOLDER_VALUE = "Select time";

/** Cache time set to 0 to ensure fresh dynamic link & listing details on modal open */
export const QR_CACHE_TIME = 0;

export const ADD_CUSTOMER_MODAL_KEY_PREFIX = "add-customer-modal";
export const MODAL_KEY_LOADING_FALLBACK = "loading";

export const QR_DETAILS_LINK_FIELD = "details_submission_link";
export const LINK_NOT_AVAILABLE_MSG =
  "Submission link not available for this record";

export const EMPTY_STATE_LABEL = "N/A";
export const QR_LINK_COPY_LABEL = "QR Link Copied!";
export const QR_LINK_COPY_FAILED_LABEL = "Failed to copy QR Link!";
export const COPY_FEEDBACK_MS = 2000;

export const QR_ACTION_IDS = {
  ADD_CUSTOMER: "add_customer",
  COPY_LINK: "copy_link",
};

export const QR_ACTION_LABELS = {
  ADD_CUSTOMER_DETAILS: "Add Customer Details",
  COPY_DETAIL_LINK: "Copy detail collection page link",
};

export const QR_BANNER_QUERY_CONFIG = {
  page: 1,
  page_size: 1,
};
export const QR_BANNER_CACHE_TIME = 60000;
export const QR_BANNER_STALE_TIME = 30000;

export const QR_CONVERTED_STRINGS = {
  TRUE: "true",
  FALSE: "false",
};

export const EMPTY_STATE_PROPS = {
  content_title: "No QR Payments yet",
  children: "As soon as QR payments are completed, they will show up here.",
};

export const PAYMENT_TYPE_OPTIONS = [
  { value: "one_time", label: "One Time" },
  { value: "subscription", label: "Subscription" },
  { value: "installment", label: "Installment" },
];

export const DEBIT_TYPE_OPTIONS = [
  { value: "auto", label: "Auto Debit" },
  { value: "manual", label: "Manual" },
];

export const QR_PAYMENT_STATUS_OPTIONS = [
  { value: "success", label: "Success" },
  { value: "failed", label: "Failed" },
];

export const INVOICE_STATUS_OPTIONS = [
  { value: "success", label: "Success" },
  { value: "failed", label: "Failed" },
];

export const FIELD_DATA = {
  upi_id: "upi_id",
  customer_name: "customer_name",
  customer_phone_number: "customer_phone",
  customer_email: "customer_email",
  listing_title: "listing_title",
  listing_type: "listing_type",
  payment_type: "payment_type",
  payment_debit_mode: "payment_debit_mode",
  amount: "amount",
  transaction_id: "transaction_uuid",
  transaction_date: "transaction_date",
  qr_payment_status: "qr_payment_status",
  invoice_status: "invoice_status",
};

export const FORM_DATA = {
  upi_id: "UPI ID",
  customer_name: "Customer Name",
  customer_phone: "Phone",
  customer_email: "Email Id",
  listing_title: "Offering Name",
  listing_type: "Offering Type",
  payment_type: "Payment Type",
  payment_debit_mode: "Debit Type",
  amount: "Transaction Amount",
  transaction_id: "Transaction ID",
  transaction_date: "Transaction Date",
  qr_payment_status: "QR Payment Status",
  invoice_status: "Invoice Status",
};

export const BANNER_COLORS = {
  SUCCESS_BG: "#ffaa00",
  FAILED_BG: "#F04438",
  SUCCESS_TEXT: "#000000",
  FAILED_TEXT: "#FFFFFF",
};

export const STATUS_BADGE_COLORS = {
  PENDING_BG: "#FFAB00",
  SUCCESS_BG: "#00B779",
  FAILED_BG: "#BF2600",
};

export const FAILED_STATUS = 3;

export const QR_PAYMENT_STATUS_CODES = {
  SUCCESS: 2,
  FAILED: 3,
};

export const QR_WARNING_BANNER_QUERY_KEYS = {
  SUCCESS_COUNT: "qr_payments_success_count",
  FAILED_COUNT: "qr_payments_failed_count",
};

export const QR_QUERY_KEYS = {
  DYNAMIC_LINK_DETAILS: "dynamic_link_details",
  LISTING_DETAILS: "listing_details",
};

export const QR_STATUS_TEXT = {
  PENDING: "Pending",
  SUCCESS: "Success",
  FAILED: "Failed",
};

export const QR_CONVERSION_TEXT = {
  CONVERTED: "Converted",
  PENDING: "Pending",
};

export const QR_TYPE_TEXT = {
  DIRECT_UPI: "Direct UPI",
  STANDARD_GATEWAY: "Standard Gateway",
};

export const QR_FILTER_KEYS = {
  CUSTOMER_FULL_NAME: "customer_full_name",
  LINK_TITLE: "link_title",
  PAYER_VPA: "payer_vpa",
  QR_ORDER_UUID: "qr_order_uuid",
  IS_CONVERTED: "is_converted",
  QR_TYPE: "qr_type",
  STATUS: "status",
  PAID_AT_START_RANGE: "paid_at__start_range",
  PAID_AT_END_RANGE: "paid_at__end_range",
  UNCLAIMED_ONLY: "unclaimed_only",
};

export const QR_FILTER_LABELS = {
  CUSTOMER_NAME: "Customer Name",
  LINK_NAME: "Link Name",
  OFFERING_NAME: "Link Name",
  UPI_ID: "UPI ID",
  TRANSACTION_ID: "Transaction ID",
  QR_TYPE: "QR Type",
  PAYMENT_STATUS: "Payment Status",
  CONVERSION_STATUS: "Conversion Status",
  TRANSACTION_DATE_FROM: "Transaction Date (From)",
  TRANSACTION_DATE_TO: "Transaction Date (To)",
};

export const QR_CHIP_DATE_FORMAT = "DD MMM YYYY";

export const TABLE_THEME_COLORS = {
  AMOUNT_TEXT: "#1D2939",
  DIRECT_UPI_BG: "#CCE0FF",
  DIRECT_UPI_TEXT: "#002966",
  STANDARD_GATEWAY_BG: "#DCD9F2",
  STANDARD_GATEWAY_TEXT: "#40329A",
};

export const BADGE_VARIANTS = {
  PENDING: "pending",
  SUCCESS: "success",
  FAILED: "failed",
};

export const BADGE_STYLES = {
  [BADGE_VARIANTS.PENDING]: {
    backgroundColor: STATUS_BADGE_COLORS.PENDING_BG,
    color: "#FFFFFF",
  },
  [BADGE_VARIANTS.SUCCESS]: {
    backgroundColor: STATUS_BADGE_COLORS.SUCCESS_BG,
    color: "#FFFFFF",
  },
  [BADGE_VARIANTS.FAILED]: {
    backgroundColor: STATUS_BADGE_COLORS.FAILED_BG,
    color: "#FFFFFF",
  },
};

export const QR_TYPE_BADGE_STYLES = {
  1: {
    bg: TABLE_THEME_COLORS.DIRECT_UPI_BG,
    text: TABLE_THEME_COLORS.DIRECT_UPI_TEXT,
    label: QR_TYPE_TEXT.DIRECT_UPI,
  },
  2: {
    bg: TABLE_THEME_COLORS.STANDARD_GATEWAY_BG,
    text: TABLE_THEME_COLORS.STANDARD_GATEWAY_TEXT,
    label: QR_TYPE_TEXT.STANDARD_GATEWAY,
  },
};

export const DAY = "day";
